import React from "react";
import className from "./SuggestOutput.module.scss";

type Props = {
  children: React.ReactNode;
  value: string;
};

const OutputItem = ({ children, value }: Props) => {
  return (
    <button className={className.button} type="button" value={value}>
      {children}
    </button>
  );
};

export default OutputItem;
